"use client"
import { useModal } from './Provdier'

export default function ExpiredModal() {
  const { isOpen, closeModal } = useModal()

  return (
    <>
        {isOpen && (
          <div className="fixed inset-0 bg-black/50">
            <section className="flex flex-col justify-center gap-y-4 w-[300px] p-5 min-h-[150px] bg-white rounded-lg absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
              <div>
                <h3>提示</h3>
                <p className="text-sm text-[#777] my-2">
                  此机构的服务已到期，请联系管理员
                </p>
              </div>

              <button className="mt-5 font-bold bg-black text-white rounded-sm text-sm text-center h-11 cursor-pointer" onClick={closeModal}>确认</button>
              </section>
            </div>
      )}
    </>
  )
}




